import firebase from "firebase/compat/app";

// live
const firebaseConfig = {
  apiKey: "AIzaSyAxGI-5sZigvsNWHdzNu6MrTrFVqyzPrrU",
  authDomain: "pay-routeline.firebaseapp.com",
  projectId: "pay-routeline",
  storageBucket: "pay-routeline.appspot.com",
  messagingSenderId: "237723228415",
  appId: "1:237723228415:web:6bc5a0904118c6f51dd4ca",
  measurementId: "G-D0DYXFLN79",
  databaseURL: "https://pay-routeline-default-rtdb.firebaseio.com",
};
// dev
// const firebaseConfig = {
//   apiKey: "AIzaSyACxhcWGrIdYyT6XrCQgUilZm2Ed6LdAQ4",
//   authDomain: "routeline-dev.firebaseapp.com",
//   databaseURL: "https://routeline-dev-default-rtdb.firebaseio.com",
//   projectId: "routeline-dev",
//   storageBucket: "routeline-dev.appspot.com",
//   messagingSenderId: "646745721601",
//   appId: "1:646745721601:web:1628de0c774c2100ffa900",
//   measurementId: "G-5B7HYF2M51",
// };

firebase.initializeApp(firebaseConfig);
